import { Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { TicketMetaField } from "../../../../../../administration/ticket_creation/types/field_configs/Meta";

type Props = {
  field: Extract<TicketMetaField, { type: "select" }>;
  name: string;
};

export const SelectInput = observer((props: Props) => {
  const options = useMemo(
    () =>
      props.field.options?.map((option) => ({
        value: option,
      })) ?? [],
    [props.field.options]
  );
  const mode = props.field.multiple ? "multiple" : undefined;

  return (
    <Form.Item
      name={props.name}
      label={props.field.label}
      help={props.field.description}
    >
      <Select options={options} mode={mode} />
    </Form.Item>
  );
});
